import { createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../api';
import { ApplyBonusToUserDto, DepositBonus, UserDepositBonusWithBonusProgress } from '@repo/common-types';

export const fetchDepositBonuses = createAsyncThunk('depositBonuses/fetch', async () => {
  const response = await api.get<DepositBonus[]>('/v1/admin/deposit-bonus');
  return response.data;
});

export const fetchUserDepositBonuses = createAsyncThunk('userDepositBonuses/fetch', async (userId: string) => {
  const response = await api.get<UserDepositBonusWithBonusProgress[]>(`/v1/admin/deposit-bonus/users/${userId}`);
  return response.data;
});

export const attachDepositBonusToUser = createAsyncThunk(
  'userDepositBonus/attach',
  async (data: ApplyBonusToUserDto, { dispatch }) => {
    try {
      const response = await api.patch<UserDepositBonusWithBonusProgress>(
        `/v1/admin/deposit-bonus/users/${data.userId}/apply`,
        data,
      );
      dispatch(fetchUserDepositBonuses(data.userId));
      return response.data;
    } catch (error) {
      console.log('attachDepositBonusToUser error', error);
    }
  },
);
